<template>
  <div>
    <nav-header title="社群币种管理" />
    <div class="body-wrapper">
      <div class="pane">
        <div class="pane-title">已添加币种</div>
        <div class="pane-content">
          <div class="empty-text row-center" v-if="!choosed.length">
            默认展示所有币种
          </div>
          <ol>
            <li
              class="item row-align-center"
              v-for="itemId in choosed"
              :key="itemId"
            >
              <img
                :src="assetsMap[itemId] && assetsMap[itemId].icon"
                alt=""
                class="item-left"
              />
              <span class="item-mid">{{
                assetsMap[itemId] && assetsMap[itemId].name
              }}</span>
              <span
                class="item-right selected row-center"
                @click="onRemove(itemId)"
              >
                <svg class="item-right-icon">
                  <use xlink:href="#icon-remove" />
                </svg>
                <span>移除</span>
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="division"></div>
      <div class="pane">
        <div class="pane-title">添加币种</div>
        <div class="pane-content">
          <div class="empty-text row-center" v-if="!unChoosed.length">
            没有更多币种了
          </div>
          <ol>
            <li
              class="item row-align-center"
              v-for="itemId in unChoosed"
              :key="itemId"
            >
              <img
                :src="assetsMap[itemId] && assetsMap[itemId].icon"
                alt=""
                class="item-left"
              />
              <span class="item-mid">{{
                assetsMap[itemId] && assetsMap[itemId].name
              }}</span>
              <span class="item-right row-center" @click="onAdd(itemId)">
                <svg class="item-right-icon">
                  <use xlink:href="#icon-add" />
                </svg>
                <span>添加</span>
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="footer-btn">
        <md-button
          :type="isSubmitting ? 'disabled' : 'primary'"
          :loading="isSubmitting"
          @click="onSubmit"
        >
          <span v-if="isSubmitting">正在保存</span>
          <span v-else>保存</span>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import navHeader from '@/components/the-nav-bar.vue';
import { Button, Toast, Dialog } from 'mand-mobile';
import { mapState } from 'vuex';
import { postUserCommunitySettings } from '@/api/user';
export default {
  components: {
    navHeader,
    [Button.name]: Button,
  },
  data() {
    return {
      isSubmitting: false,
      isLoaded: false,
      choosed: [],
      unChoosed: [],
      assetsMap: {},
    };
  },
  computed: mapState({
    communitySettings: state => state.communitySettings,
    env: state => state.env,
  }),
  methods: {
    onSubmit() {
      this.isSubmitting = true;
      postUserCommunitySettings(
        this.env.conversationId,
        this.choosed,
        this.communitySettings.property,
      )
        .then(() => {
          this.isSubmitting = false;
          this.$router.back();
          Toast.succeed('保存成功', 1000);
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            title: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    onRemove(itemId) {
      if (this.isSubmitting) return;
      const index = this.choosed.indexOf(itemId);
      if (index > -1) {
        this.choosed.splice(index, 1);
        this.unChoosed.push(itemId);
      }
    },
    onAdd(itemId) {
      if (this.isSubmitting) return;
      const index = this.unChoosed.indexOf(itemId);
      if (index > -1) {
        this.unChoosed.splice(index, 1);
        this.choosed.push(itemId);
      }
    },
  },
  mounted() {
    let promise = Promise.resolve();
    if (this.communitySettings.loadStatus !== 'success') {
      promise = this.$store.dispatch('updateUserCommunitySettings');
    }
    promise
      .then(() => {
        this.communitySettings.choose.forEach(item => {
          this.assetsMap[item.id] = item;
          this.choosed.push(item.id);
        });
        this.communitySettings.assets.forEach(item => {
          this.assetsMap[item.id] = item;
          this.unChoosed.push(item.id);
        });
        this.isLoaded = true;
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-bottom: 40vw;

  .pane {
    padding: 4.8vw;

    .pane-title {
      margin-bottom: 4.8vw;
      font-size: 3.2vw;
      color: color-text-caption;
    }
  }

  .division {
    height: 1px;
    background: #EAF1F3;
  }

  .empty-text {
    min-height: 20vw;
    font-size: 3.2vw;
    color: color-text-caption;
  }
}

.item {
  margin: 4.8vw 0;
  height: 6.4vw;
  line-height: 6.4vw;
  font-size: 3.73vw;
  font-weight: bold;

  .item-left {
    width: 6.4vw;
    height: 6.4vw;
  }

  .item-mid {
    margin: 0 2.13vw;
    flex: 1 0 0;
    color: color-text-caption;
  }

  .item-right {
    font-size: 3.2vw;
    color: color-primary;

    &.selected {
      color: #dc521b;
    }

    .item-right-icon {
      margin-right: 1.07vw;
      width: 4.8vw;
      height: 4.8vw;
    }
  }
}

.footer-btn {
  position: fixed;
  left: 4.8vw;
  right: 4.8vw;
  bottom: 0;
  bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  bottom: env(safe-area-inset-bottom); /* iOS 11.2 */

  .md-button {
    margin-bottom: 9.6vw;
  }
}
</style>
